import Component from "@base/Component.js";
import t from "@/services/translationService.js";

/**
 * Row actions for the Cockpit tables.
 *
 * Icon-only on purpose: the actions column is the first thing to overflow on a
 * narrow screen, and "View"/"Edit" set in the button font ran about three times
 * wider than the glyph they replace. The words survive as `aria-label` + native
 * tooltip, so nothing is lost to a screen reader or to a hovering mouse.
 *
 * Same icon idiom as the Cockpit's nav (cockpitSections.js) and the rich-text
 * toolbar: 20x20, stroke-only, `currentColor` — so one rule colours a button
 * and its glyph together.
 */
const icon = (paths) =>
  `<svg class="row-action__glyph" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${paths}</svg>`;

export const ICONS = {
  view: icon(`<path d="M1.8 10S4.9 4.6 10 4.6 18.2 10 18.2 10 15.1 15.4 10 15.4 1.8 10 1.8 10Z"/><circle cx="10" cy="10" r="2.4"/>`),
  edit: icon(`<path d="M13.8 3.2a1.9 1.9 0 0 1 2.7 2.7l-8.6 8.6-3.5 1 1-3.5 8.4-8.8Z"/><path d="m12.7 4.4 2.9 2.9"/>`),
};

/**
 * "View" — a link, not a button: it navigates to the entity's public page.
 * `draggable="false"` because the Gear Manager's rows are drag-to-reorder, and
 * a link inside one would otherwise start its own native link-drag instead.
 */
export function viewLink(href) {
  const label = t.t("common.view");
  return `<a class="row-action" href="${href}" draggable="false" aria-label="${Component.escape(label)}" title="${Component.escape(label)}">${ICONS.view}</a>`;
}

/** "Edit" — opens the entity's editor overlay; wire it up via [data-edit]. */
export function editButton(id) {
  const label = t.t("common.edit");
  return `<button type="button" class="row-action" data-edit="${Component.escape(id)}" aria-label="${Component.escape(label)}" title="${Component.escape(label)}">${ICONS.edit}</button>`;
}
